import { MenuList } from "./MenuList";
import { getUserSession } from "./Session";

export const VerifyPermission = () => {

    const session = getUserSession();
    const menuFunctionalities = MenuList(session.menu).filter((menu) => { return menu.type != "2" });

    let currentFunctionality;

    const currentUrl = window.location.href;
    let funcPath = '/' + currentUrl.split('/').slice(3).join('/');

    if (!funcPath.includes('#')) {
        funcPath += '#';
    }

    const pathExists = menuFunctionalities.some(functionality => {

        if (functionality.path) {
            if (!functionality.path.includes('#')) {
                functionality.path += '#';
            }

            const functionalityPathParts = functionality.path.split('/');
            const functionalityPathPrefix = functionalityPathParts.slice(0, 2).join('/');

            if (funcPath.startsWith(functionalityPathPrefix)) {
                currentFunctionality = functionality;
                return true;
            }
        }

        return false;
    });

    if (!pathExists) {
        let direcionamento = currentUrl.split('/');
        direcionamento = `${direcionamento[0]}//${direcionamento[2]}${menuFunctionalities[0].path}`;

        if (funcPath === "/#") {
            return false;
        }

        window.location.href = direcionamento;
    }

    return currentFunctionality || false;
};
